<template>
  <div class="contacts" :class="{ 'contacts-skeleton-group': pageLoading }">
    <!-- Simple Header -->
    <div class="simple-header">
      <button v-on:click="$router.go(-1)" v-if='$route.meta.name != "خانه"' class="back-btn">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <span class="page-title">{{$route.meta.name}}</span>
      <div class="header-spacer"></div>
    </div>

    <!-- Action Buttons -->
    <div v-if="pageLoading" class="action-buttons" aria-hidden="true">
      <div class="skeleton-block skeleton-action-btn"></div>
      <div class="skeleton-block skeleton-action-btn"></div>
    </div>
    <div v-else class="action-buttons">
      <button class="action-btn" v-on:click="goAddGroup()">
        <div class="action-icon bg-blue-100">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 8V14" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17 11H23" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>افزودن گروه</span>
      </button>

      <button class="action-btn" @click="dialog = true">
        <div class="action-icon bg-green-100">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="#10B981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>افزودن مخاطب</span>
      </button>
    </div>

    <!-- Contacts List -->
    <div v-if="pageLoading" class="contacts-list" aria-hidden="true">
      <div
        v-for="n in skeletonContactCount"
        :key="'contact-sk-' + n"
        class="contact-preview skeleton-contact-item"
      >
        <div class="contact-row gap-4">
          <div class="skeleton-block skeleton-avatar"></div>
          <div class="skeleton-lines flex-grow">
            <div class="skeleton-block skeleton-line skeleton-line-md"></div>
            <div class="skeleton-block skeleton-line skeleton-line-sm mt-2"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="contacts-list">
      <div
        class="contact-preview"
        v-for="item in items"
        :key="item.UserContactId || item.ContactId"
        v-on:click="goToDetail(item)"
      >
        <div class="contact-row gap-4" @contextmenu="openMenu($event, item)">
          <div class="contact-avatar">
            <img :src="item.ImageUrl" />
          </div>
          <div class="">
            <span class="contact-username">
              {{ item.UserName }}
            </span>
            <span class="contact-code-text">
              {{ item.UserCode }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Context Menu -->
    <div v-if="showMenu" class="context-menu" :style="{ left: x + 'px', top: y + 'px' }">
      <div class="context-item" v-on:click="removeMessage(show_detail)">
        حذف
      </div>
    </div>

    <!-- Add Contact Modal -->
    <div v-if="dialog" class="modal-overlay" @click="dialog = false">
      <div class="modal" @click.stop>
        <div class="modal-content">
          <div class="add-header">{{ $t('addContact') }}<img src="../../../public/img/zoodkomak.png" />
          </div>

          <div class="form-content">
            <div class="input-group" :data-label="$t('contactPhoneNo')">
              <img class="input-icon" src="/img/smartphone.svg" alt="phone" />
              <input
                v-model="contact_phone"
                class="input"
                type="tel"
                placeholder="09123456789"
                style="text-align: right;"
              />
            </div>
          </div>

          <div class="modal-footer">
            <div class="button-row">
              <button class="btn secondary" @click="dialog = false">{{ $t('cancel') }}</button>
              <button class="btn primary" v-on:click="AddContact()">{{ $t('ok') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Second Modal -->
    <div v-if="dialog2" class="modal-overlay" @click="dialog2 = false">
      <div class="modal" @click.stop>
        <div class="modal-content">
          <div class="add-header">{{ $t('add_contact') }}<img src="../../../public/img/zoodkomak.png" />
          </div>

          <div class="form-content">
            hi
          </div>

          <div class="modal-footer">
            <div class="button-row">
              <button class="btn secondary" @click="dialog2 = false">{{ $t('cancel') }}</button>
              <button class="btn primary" v-on:click="AddContact()">{{ $t('ok') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { bus } from '../../main'
import { skeletonSilentRequest } from '../../utils/skeletonPages'

export default {
  data () {
    return {
      phone: '',
      password: '',
      lastItemId: 0,
      lastLogId: 0,
      dialog: false,
      dialog2: false,
      contact_phone: '',
      items: [],
      showMenu: false,
      show_detail: '',
      x: 0,
      y: 0,
      pageLoading: true,
      skeletonContactCount: 8,
    }
  },
  methods: {
    goToDetail (item) {
      console.log('iteem', item)
      const last_chat_detail = {
        RecType: 0,
        UserOrGroupId : item.ContactId,
        GetReceiver : item.GetReceiver
      }
      localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
      this.$router.push({ name: this.$t('conversation'), params: {} })
    },
    openMenu (e, item) {
      console.log('open', item)
      this.show_detail = item
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    removeMessage (item) {
      console.log('remove : ' + JSON.stringify(item))
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        RecId: item.UserContactId,
        ContactName: item.UserName
      }
      var self = this
      this.axios.post('/DeleteUserContact', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            console.log('response delete ', response.data)
          }
        }).catch(e => {

      })
    },
    backToChats () {
      // this.$router.push({ path: '/dashboard', params: {} })
      this.$router.go(-1)
    },
    async getAllContacts () {
      this.phone = localStorage.getItem('phone')
      this.password = localStorage.getItem('password')
      const send_data = {
        Phone: this.phone,
        Password: this.password,
        LastItemId: this.lastItemId,
        LastLogId: this.lastLogId
      }

      try {
        const response = await this.axios.post('/ShowAllGroupContacts', send_data, skeletonSilentRequest)
        if (response.data.error == 0) {
          this.items = response.data.contacts || []
        }
      } catch (e) {
        // keep skeleton hidden; list stays empty
      }
    },
    AddContact () {
      this.phone = localStorage.getItem('phone')
      this.password = localStorage.getItem('password')
      // console.log("hi" + this.contact_phone.substring(1))
      var editedphone = this.contact_phone.substring(1)
      editedphone = '+98' + editedphone
      // this.contact_phone = this.contact_phone.replace('0', '+98');
      const send_data = {
        UserPhone:this.phone,
        ContactPhone: editedphone,
        Password: this.password
      }
      var self = this
      this.axios.post('/AddUserContact', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            console.log('response edit', response.data)
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {

      })
    },
    DeleteContact () {
      this.dialog2 = true
    },
    goAddGroup () {
      this.$router.push({ path: '/add-group', params: {} })
    },
    mousePress () {
      console.log('hi')
    },
    mouseRelease () {
      console.log('hello')
    }
  },
  async mounted () {
    try {
      await this.getAllContacts()
    } finally {
      this.pageLoading = false
    }
  }
}
</script>
<style scoped>
  .contacts {
    min-height: 100vh;
    background: #f8fafc;
  }

  /* Simple Header */
  .simple-header {
    display: flex;
    align-items: center;
    padding: 16px;
    background: white;
    border-bottom: 1px solid #e2e8f0;
  }

  .back-btn {
    width: 40px;
    height: 40px;
    border: none;
    background: transparent;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    color: #374151;
  }

  .back-btn:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .page-title {
    flex: 1;
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    text-align: center;
  }

  .header-spacer {
    width: 40px;
  }

  /* Action Buttons */
  .action-buttons {
    display: flex;
    gap: 12px;
    padding: 16px;
    background: white;
    border-bottom: 1px solid #e2e8f0;
  }

  .action-btn {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }

  .action-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }

  .action-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bg-blue-100 {
    background-color: #dbeafe;
  }

  .bg-green-100 {
    background-color: #dcfce7;
  }

  /* Contacts List */
  .contacts-list {
    padding: 16px;
  }

  .contact-preview {
    background: white;
    border-radius: 12px;
    margin-bottom: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .contact-preview:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .contact-row {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
  }

  .contact-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
  }

  .contact-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }


  .contact-username {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
  }

  .contact-code-text {
    font-size: 13px;
    color: #6b7280;
  }

  /* Context Menu */
  .context-menu {
    position: fixed;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    min-width: 120px;
  }

  .context-item {
    padding: 12px 16px;
    cursor: pointer;
    color: #dc2626;
    font-size: 14px;
    transition: background-color 0.2s ease;
  }

  .context-item:hover {
    background-color: #fef2f2;
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1002;
    padding: 16px;
  }

  .modal {
    background: white;
    border-radius: 16px;
    max-width: 500px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .modal-content {
    padding: 24px;
  }

  .add-header {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .form-content {
    margin: 20px 0;
  }

  /* Native input styles (match profile pages) */
  .input-group {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(248, 250, 252, 0.9);
    border: 0.5px solid rgba(226, 232, 240, 0.4);
    border-radius: 10px;
    min-height: 56px;
    padding: 0 16px 0 16px;
    transition: all 0.2s ease;
  }
  .input-group:focus-within {
    border-color: #1c39bb;
    background: rgba(255, 255, 255, 0.95);
  }
  .input-group::before {
    content: attr(data-label);
    position: absolute;
    top: -10px;
    right: 12px;
    background: #fff;
    padding: 0 6px;
    border-radius: 6px;
    font-size: 12px;
    color: #475569;
    opacity: 0.9;
  }
  .input-icon {
    position: absolute;
    left: 12px;
    width: 22px;
    height: 22px;
    opacity: 0.8;
  }
  .input {
    width: 100%;
    height: 44px;
    border: none;
    outline: none;
    background: transparent;
    font-size: 15px;
    color: #111827;
  }

  .button-row {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }

  .btn {
    flex: 1;
    height: 48px;
    border: 0;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  .btn:hover::before { left: 100%; }
  .btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
  .btn:not(:disabled):hover { transform: translateY(-1px); }
  
  .primary { 
    color: #ffffff; 
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%); 
    box-shadow: 0 2px 8px rgba(28, 57, 187, 0.2); 
  }
  .secondary { 
    color: #475569; 
    background: #f8fafc; 
    border: 1px solid #e2e8f0; 
  }
  .secondary:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  .contacts-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .contacts-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: contacts-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton-block {
    background-color: #e5e7eb;
  }

  .skeleton-action-btn {
    flex: 1;
    height: 64px;
    border-radius: 12px;
  }

  .skeleton-contact-item {
    pointer-events: none;
  }

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .skeleton-lines {
    min-width: 0;
  }

  .skeleton-line {
    border-radius: 6px;
  }

  .skeleton-line-md {
    width: 9rem;
    height: 0.9375rem;
  }

  .skeleton-line-sm {
    width: 5.5rem;
    height: 0.8125rem;
  }

  @keyframes contacts-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
